import { Component, OnInit } from '@angular/core'
import { FieldArrayType } from '@ngx-formly/core'
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop'

@Component({
  selector: 'basin-formly-repeat-single',
  templateUrl: './formly-repeat-single.component.html',
  styleUrls: ['./formly-repeat-single.component.scss'],
})
export class FormlyRepeatSingleComponent
  extends FieldArrayType
  implements OnInit
{
  input: string = ''
  constructor() {
    super()
  }

  ngOnInit(): void {
    this.props['add'] = this.add.bind(this)
    this.props['remove'] = this.remove.bind(this)
  }

  addFieldWithValue() {
    if (this.input.length > 1) {
      this.add(undefined, { option: this.input })
      this.resetInput()
    }
  }

  newField(newfield: any) {
    newfield.defaultValue = this.input
    return newfield
  }

  resetInput() {
    this.input = ''
  }

  drop(event: CdkDragDrop<string[]>) {
    if (this.field.fieldGroup) {
      moveItemInArray(this.model, event.previousIndex, event.currentIndex)
      moveItemInArray(
        this.formControl.controls,
        event.previousIndex,
        event.currentIndex
      )
      moveItemInArray(
        this.field.fieldGroup,
        event.previousIndex,
        event.currentIndex
      )
    }
    this.formControl.updateValueAndValidity()
  }
}
